// extracted by mini-css-extract-plugin
export var container = "CategoryTag-module--container--ff213";
export var title = "CategoryTag-module--title--8ffb5";